var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "m-inbox" } },
    [
      _vm.loading
        ? _c(
            "v-overlay",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "primary" },
              }),
            ],
            1
          )
        : _vm.message
        ? _c(
            "v-alert",
            {
              staticStyle: {
                "margin-top": "50px",
                "margin-left": "50%",
                left: "-10%",
              },
              attrs: { type: "error", width: "20%" },
            },
            [_vm._v(" " + _vm._s(_vm.message) + " ")]
          )
        : _c(
            "v-card",
            { attrs: { elevation: "0" } },
            [
              _vm.usersCountPerPackage.length != 0
                ? _c(
                    "v-card-actions",
                    { staticClass: "ma-0 pa-0 mx-2 my-2" },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { outlined: "", width: "100%" },
                        },
                        [
                          _c(
                            "v-card-actions",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c("v-data-table", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "fixed-header": "",
                                  headers: _vm.header,
                                  items: _vm.usersCountPerPackage,
                                  "hide-default-footer": "",
                                  "disable-pagination": "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }